import React, { Fragment } from "react";

function PrivacyPolicy() {
  const currentDate = new Date().toLocaleDateString('fr-FR', { 
    year: 'numeric', 
    month: 'long', 
    day: 'numeric' 
  });

  return (
    <Fragment>
      <div className="privacy-policy">
        {/* Header avec navigation */}
        <div className="privacy-header">
          <a href="/" className="back-link">
            ← Retour à l'accueil
          </a>
        </div>

        {/* Contenu principal */}
        <div className="privacy-container">
          <div className="privacy-card">
            <div className="privacy-title">
              <h1>Politique de Confidentialité</h1>
              <h2>Falla CNI</h2>
              <p className="last-updated">
                <strong>Dernière mise à jour :</strong> {currentDate}
              </p>
            </div>

            <div className="privacy-content">
              <section className="privacy-section">
                <h3>1. Introduction</h3>
                <p>
                  Falla CNI respecte votre vie privée et s'engage à protéger vos données personnelles. Cette politique de confidentialité explique comment nous collectons, utilisons et protégeons vos informations lorsque vous utilisez notre application mobile.
                </p>
              </section>

              <section className="privacy-section">
                <h3>2. Informations que nous collectons</h3>
                
                <div className="subsection">
                  <h4>2.1 Informations que vous nous fournissez</h4>
                  <ul>
                    <li><strong>Recherches CNI :</strong> Les numéros de cartes d'identité que vous recherchez</li>
                    <li><strong>Données de contact :</strong> Uniquement si vous choisissez de contacter des personnes via l'app</li>
                  </ul>
                </div>

                <div className="subsection">
                  <h4>2.2 Informations collectées automatiquement</h4>
                  <ul>
                    <li><strong>Données d'utilisation :</strong> Fréquence d'utilisation, fonctionnalités utilisées</li>
                    <li><strong>Informations techniques :</strong> Type d'appareil, version du système d'exploitation</li>
                    <li><strong>Données de connexion :</strong> Adresses IP, journaux d'accès pour la sécurité</li>
                  </ul>
                </div>
              </section>

              <section className="privacy-section">
                <h3>3. Comment nous utilisons vos informations</h3>
                <p>Nous utilisons vos informations pour :</p>
                <ul>
                  <li><strong>Fournir le service :</strong> Effectuer les recherches CNI demandées</li>
                  <li><strong>Améliorer l'application :</strong> Analyser l'utilisation pour optimiser les fonctionnalités</li>
                  <li><strong>Assurer la sécurité :</strong> Prévenir les abus et maintenir la sécurité du service</li>
                  <li><strong>Support technique :</strong> Résoudre les problèmes techniques</li>
                </ul>
              </section>

              <section className="privacy-section">
                <h3>4. Partage de vos informations</h3>
                
                <div className="subsection">
                  <h4>4.1 Nous ne partageons PAS vos données avec :</h4>
                  <ul>
                    <li>Des entreprises publicitaires</li>
                    <li>Des courtiers en données</li>
                    <li>Des réseaux sociaux à des fins marketing</li>
                  </ul>
                </div>

                <div className="subsection">
                  <h4>4.2 Nous pouvons partager des informations dans ces cas :</h4>
                  <ul>
                    <li><strong>Exigences légales :</strong> Si requis par la loi ou les autorités compétentes</li>
                    <li><strong>Prestataires de services :</strong> Avec nos partenaires techniques (hébergement, sécurité) sous contrat strict</li>
                    <li><strong>Protection des droits :</strong> Pour protéger nos droits, votre sécurité ou celle d'autrui</li>
                  </ul>
                </div>
              </section>

              <section className="privacy-section">
                <h3>5. Sécurité des données</h3>
                <p>Nous mettons en place des mesures de sécurité appropriées :</p>
                <ul>
                  <li><strong>Chiffrement :</strong> Toutes les données sont chiffrées en transit et au repos</li>
                  <li><strong>Accès restreint :</strong> Seul le personnel autorisé a accès aux données</li>
                  <li><strong>Surveillance :</strong> Monitoring constant des systèmes pour détecter les intrusions</li>
                  <li><strong>Mises à jour :</strong> Mise à jour régulière des systèmes de sécurité</li>
                </ul>
              </section>

              <section className="privacy-section">
                <h3>6. Vos droits</h3>
                <p>Conformément aux lois sur la protection des données, vous avez le droit de :</p>
                <ul>
                  <li><strong>Accéder</strong> à vos données personnelles</li>
                  <li><strong>Rectifier</strong> des informations inexactes</li>
                  <li><strong>Supprimer</strong> vos données (droit à l'oubli)</li>
                  <li><strong>Limiter</strong> le traitement de vos données</li>
                  <li><strong>Transférer</strong> vos données vers un autre service</li>
                  <li><strong>Vous opposer</strong> au traitement de vos données</li>
                </ul>
              </section>

              <section className="privacy-section">
                <h3>7. Conservation des données</h3>
                <ul>
                  <li><strong>Données de recherche :</strong> Conservées 30 jours maximum</li>
                  <li><strong>Logs techniques :</strong> Conservés 90 jours pour la sécurité</li>
                  <li><strong>Données de support :</strong> Supprimées après résolution du problème</li>
                </ul>
              </section>

              <section className="privacy-section">
                <h3>8. Services tiers</h3>
                <p>L'application peut utiliser des services tiers :</p>
                <ul>
                  <li><strong>WhatsApp :</strong> Pour les fonctions de contact (soumis à la politique WhatsApp)</li>
                  <li><strong>Services de téléphonie :</strong> Pour les appels directs</li>
                  <li><strong>Hébergement cloud :</strong> Pour le stockage sécurisé des données</li>
                </ul>
              </section>

              <section className="privacy-section">
                <h3>9. Protection des mineurs</h3>
                <p>
                  Notre service n'est pas destiné aux personnes de moins de 18 ans. Nous ne collectons pas sciemment d'informations personnelles auprès de mineurs.
                </p>
              </section>

              <section className="privacy-section">
                <h3>10. Modifications de cette politique</h3>
                <p>Nous pouvons modifier cette politique de confidentialité. Les modifications importantes seront notifiées via :</p>
                <ul>
                  <li>Notification dans l'application</li>
                  <li>Email (si vous nous avez fourni votre adresse)</li>
                  <li>Mise à jour de la date en haut de cette page</li>
                </ul>
              </section>

              <section className="privacy-section">
                <h3>11. Contact</h3>
                <p>Pour toute question concernant cette politique de confidentialité ou vos données personnelles :</p>
                <div className="contact-info">
                  <p><strong>Email :</strong> contact@flowfactory.fr</p>
                  <p><strong>Adresse :</strong> Messamendongo, Odza, Yaoundé</p>
                </div>
              </section>

              <section className="privacy-section">
                <h3>12. Juridiction</h3>
                <p>
                  Cette politique est régie par les lois du Cameroun. Tout litige sera soumis aux tribunaux compétents de [Votre ville].
                </p>
              </section>

              <div className="privacy-footer">
                <div className="acceptance-notice">
                  <strong>En utilisant l'application Falla CNI, vous acceptez cette politique de confidentialité.</strong>
                </div>
                
                <div className="privacy-actions">
                  <a href="/" className="button button-primary">
                    Retour à l'accueil
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .privacy-policy {
          min-height: 100vh;
          background: linear-gradient(135deg, #5c993e 0%, #4a7a32 100%);
          padding: 20px 0;
        }

        .privacy-header {
          max-width: 1200px;
          margin: 0 auto;
          padding: 20px;
        }

        .back-link {
          color: white;
          text-decoration: none;
          font-size: 16px;
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 10px 15px;
          background: rgba(255, 255, 255, 0.1);
          border-radius: 25px;
          transition: all 0.3s ease;
        }

        .back-link:hover {
          background: rgba(255, 255, 255, 0.2);
          transform: translateX(-5px);
        }

        .privacy-container {
          max-width: 900px;
          margin: 0 auto;
          padding: 0 20px;
        }

        .privacy-card {
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(10px);
          border-radius: 20px;
          padding: 40px;
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
          border: 1px solid rgba(255, 255, 255, 0.2);
          margin-bottom: 40px;
        }

        .privacy-title {
          text-align: center;
          margin-bottom: 40px;
          padding-bottom: 30px;
          border-bottom: 2px solid #5c993e;
        }

        .privacy-title h1 {
          font-size: 2.5rem;
          color: #5c993e;
          margin-bottom: 10px;
          font-weight: 700;
        }

        .privacy-title h2 {
          font-size: 1.5rem;
          color: #4a7a32;
          margin-bottom: 15px;
          font-weight: 600;
        }

        .last-updated {
          color: #666;
          font-size: 0.9rem;
          font-style: italic;
        }

        .privacy-content {
          line-height: 1.7;
          color: #333;
        }

        .privacy-section {
          margin-bottom: 30px;
        }

        .privacy-section h3 {
          color: #5c993e;
          font-size: 1.4rem;
          margin-bottom: 15px;
          font-weight: 600;
          border-left: 4px solid #5c993e;
          padding-left: 15px;
        }

        .subsection {
          margin: 20px 0;
          padding-left: 15px;
        }

        .subsection h4 {
          color: #4a7a32;
          font-size: 1.1rem;
          margin-bottom: 10px;
          font-weight: 600;
        }

        .privacy-section ul {
          margin: 15px 0;
          padding-left: 20px;
        }

        .privacy-section li {
          margin-bottom: 8px;
          list-style-type: disc;
        }

        .privacy-section p {
          margin-bottom: 15px;
          text-align: justify;
        }

        .contact-info {
          background: #f8f9fa;
          padding: 20px;
          border-radius: 10px;
          border-left: 4px solid #5c993e;
          margin: 15px 0;
        }

        .contact-info p {
          margin-bottom: 8px;
        }

        .privacy-footer {
          margin-top: 40px;
          padding-top: 30px;
          border-top: 2px solid #eee;
          text-align: center;
        }

        .acceptance-notice {
          background: linear-gradient(135deg, #5c993e, #4a7a32);
          color: white;
          padding: 20px;
          border-radius: 15px;
          margin-bottom: 30px;
          font-size: 1.1rem;
        }

        .privacy-actions {
          display: flex;
          justify-content: center;
          gap: 20px;
        }

        .button {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          padding: 12px 30px;
          border-radius: 25px;
          text-decoration: none;
          font-weight: 600;
          transition: all 0.3s ease;
          border: none;
          cursor: pointer;
        }

        .button-primary {
          background: linear-gradient(135deg, #5c993e, #4a7a32);
          color: white;
        }

        .button-primary:hover {
          transform: translateY(-2px);
          box-shadow: 0 10px 20px rgba(92, 153, 62, 0.3);
        }

        @media (max-width: 768px) {
          .privacy-card {
            padding: 20px;
            margin: 10px;
          }

          .privacy-title h1 {
            font-size: 2rem;
          }

          .privacy-title h2 {
            font-size: 1.3rem;
          }

          .privacy-section h3 {
            font-size: 1.2rem;
          }

          .back-link {
            font-size: 14px;
          }
        }
      `}</style>
    </Fragment>
  );
}

export default PrivacyPolicy;